export const FileGroupId = {
  ENDORSEMENT: "9908c721-8a8b-4642-a84b-69da4b02ade9",
};
